import type { ArtigoComentadoDetalhe } from '@titularis/api-client';
import { formatarCusto, MOTOR_ASSISTIDO_LABEL } from '../../dominio';

/**
 * De onde veio o comentário do artigo, e o que ele custou (G-COST).
 *
 * **Mora fora da gaveta porque é a regra que decide o que *não* aparece**, e é
 * essa metade que erra calada: o comentário escrito à mão não tem run nenhum, e
 * o run que fechou antes de o gancho medir tem custo `0`. Uma linha montada
 * dentro do JSX diria "Sugerido pelo Claude Code · US$ 0,00" sobre um texto que
 * uma pessoa escreveu - e nenhum teste veria.
 *
 * **A máquina não é usuário** (D-17): a sugestão não tem autor, e dizer "por
 * Fulano" atribuiria a alguém um texto que ele não escreveu. O que cabe dizer é
 * o fato - qual motor, qual modelo, quantos dólares -, que é a mesma linha que o
 * histórico da questão mostra.
 */
export function origemDoComentario(
  artigo:
    | Pick<ArtigoComentadoDetalhe, 'ingestionEngine' | 'ingestionModel' | 'ingestionCostUsd'>
    | undefined,
): string {
  if (!artigo) return '';

  return [
    /*
     * "pela máquina", com o motor entre parênteses, é a forma que o histórico da
     * questão já usa - e o rótulo do motor sai do `dominio` justamente para
     * caber ali: `nuvem` é substantivo comum, e "Sugerido pela nuvem" nomearia o
     * motor como se ele fosse o autor.
     */
    artigo.ingestionEngine
      ? `Sugerido pela máquina (${MOTOR_ASSISTIDO_LABEL[artigo.ingestionEngine]})`
      : null,
    artigo.ingestionModel,
    formatarCusto(artigo.ingestionCostUsd),
  ]
    .filter(Boolean)
    .join(' · ');
}
